import { render, staticRenderFns } from "./SettingsNotificationMailing.vue?vue&type=template&id=fd8b0ec0&"
import script from "./SettingsNotificationMailing.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationMailing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports